import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import i18n from 'i18n';

import shortText from 'modules/legacy/js/lib/short-text';
import {VerificationBadge} from 'modules/shared/components';
import SocialAvatar from 'modules/legacy/js/components/social-avatar';

const MAX_USERNAME_LENGTH = 20;

const SocialAvatarInfluencer = createClass({

  propTypes: {
    size: PropTypes.string,
    socialAccount: PropTypes.object.isRequired,
    publicationType: PropTypes.string,
    className: PropTypes.string
  },

  getDisplayName(socialAccount) {
    const {_id, username = '', url} = socialAccount;
    let displayName = shortText(username, MAX_USERNAME_LENGTH);

    if (!_id) displayName = '...';
    if (!url) return <span className='vf-text-primary'>{displayName}</span>;
    return (
      <a href={url} data-uitest='sna-username' target='_blank'>{displayName}</a>
    );
  },

  getContent() {
    const {children, socialAccount} = this.props;
    const {
      _id,
      accountType,
      isAuthorized,
      isVerified,
      audience = 0
    } = socialAccount;
    const interests = socialAccount.interests || [];
    const isIncomplete = _id && (!interests.length || !accountType);
    let content = `${audience.toLocaleString()} ${i18n.get('INF_SOCIAL_ACCOUNTS_FOLLOWERS_LABEL')}`;

    if (isAuthorized === false) {
      content = i18n.get('INF_SOCIAL_ACCOUNTS_AVATAR_CONTENT_UNAUTHORIZED');
    }
    if (isIncomplete) {
      content = i18n.get('INF_SOCIAL_ACCOUNTS_AVATAR_CONTENT_INCOMPLETE');
    }
    if (children) content = children;
    if (!_id) content = '...';

    return (
      <div>
        <div className='flex'>
          {this.getDisplayName(socialAccount)}
          {isVerified && <VerificationBadge size='sm' />}
        </div>
        <div className='vf-text-gray'>
          {content}
        </div>
      </div>
    );
  },

  render() {
    const {socialAccount, className, size = 'sm', publicationType} = this.props;

    return (
      <SocialAvatar
        size={size}
        className={className}
        socialAccount={socialAccount}
        publicationTypes={[publicationType]}
      >
        <div className='flex-column flex-start margin-left-1x'>
          {this.getContent()}
        </div>
      </SocialAvatar>
    );
  }
});

export default SocialAvatarInfluencer;
